import { render, staticRenderFns } from "./AdvicePermissionDialog.vue?vue&type=template&id=465c330a"
import script from "./AdvicePermissionDialog.vue?vue&type=script&lang=js"
export * from "./AdvicePermissionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports